<!-- case refunded -->
<div
	*ngIf="refundData?.refundStatus != 1"
	class="max-tablet:block flex gap-3 rounded-lg"
>
	<div class="flex-col w-full">
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3"
		>
			<div class="border-b-2 pt-5 flex justify-between items-center">
				<p
					class="text-font-18 mt-3 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'REFUND.REFUND_DETAILS.REFUND_INFO' | translate }}
				</p>

				<app-status
					[enumData]="refundStatus"
					[statusValue]="refundData?.refundStatus"
				></app-status>
			</div>
			<div class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REQUEST_NO' | translate }}
				</p>
				<p class="text-[#007AFF] text-font-12 w-[50%]">#{{ refundData?.id }}</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.BOOKING_NO' | translate }}
				</p>
				<p
					[routerLink]="
						'../../../booking/booking-details/' + refundData?.appointmentId
					"
					class="text-medium-gray text-font-12 w-[50%] cursor-pointer"
				>
					#{{ refundData?.appointmentSerialNumber }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REQUEST_DATE' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.requestDate | date : 'dd / MM / yyy' }}
				</p>
			</div>
			<div *ngIf="refundData?.refundStatus == 2" class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REFUND_DATE' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.refundDate | date : 'dd / MM / yyy' }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.TIME' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.refundDate | date : 'h:mm a' : 'UTC' }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REQUEST_REASON' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.requestReason }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REQUEST_AMOUNT' | translate }}
				</p>
				<p
					class=" text-font-12 w-[50%] {{
						refundData?.refundStatus == 3
							? 'text-[#B3261E]'
							: 'text-medium-gray'
					}}"
				>
					{{ refundData?.requestAmount }}
					{{
						translate.currentLang == 'ar'
							? refundData?.currency?.name?.ar
							: refundData?.currency?.name?.en
					}}
				</p>
			</div>
			<div *ngIf="refundData?.refundStatus == 2" class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REFUND_AMOUNT' | translate }}
				</p>
				<p class="text-[#00BA88] text-font-12 w-[50%]">
					{{ refundData?.requestAmount }}
					{{
						translate.currentLang == 'ar'
							? refundData?.currency?.name?.ar
							: refundData?.currency?.name?.en
					}}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.BOOKING_AMOUNT' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.bookingAmount }}
					{{
						translate.currentLang == 'ar'
							? refundData?.currency?.name?.ar
							: refundData?.currency?.name?.en
					}}
				</p>
			</div>
			<div class="flex">
				<p *ngIf="refundData?.refundStatus == 2" class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REFUND_BY' | translate }}
				</p>
				<p *ngIf="refundData?.refundStatus == 3" class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REJ_BY' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.actionUserName }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{
						refundData?.refundStatus == 2
							? ('REFUND.REFUND_DETAILS.ACC_REASON' | translate)
							: refundData?.refundStatus == 3
							? ('REFUND.REFUND_DETAILS.REJ_REASON' | translate)
							: ''
					}}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.refundActionReason }}
				</p>
			</div>
		</div>
	</div>

	<div class="flex-col w-full">
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3 min-h-[200px]"
		>
			<div class="border-b-2 pt-5 flex justify-between">
				<p
					class="text-font-18 mt-5 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'REFUND.REFUND_DETAILS.CLIENT_INFO' | translate }}
				</p>
				<button
					[routerLink]="
						'../../../clients/client-profile/' + refundData?.client?.id
					"
					class="border border-solid border-secondry-color-Gray text-dark-grey hover:bg-gradient hover:text-off-white rounded-lg max-mobile:text-[8px]"
					mat-button
				>
					{{ 'REFUND.REFUND_DETAILS.VIEW_PROFILE' | translate }}
				</button>
			</div>
			<div class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.CLIENT_NAME' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.client?.name }}
				</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.PHONE' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.client?.mobileNumber }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">{{ 'REFUND.REFUND_DETAILS.EMAIL' | translate }}</p>
				<div class="flex flex-col leading-3">
					<p class="text-medium-gray text-font-12">
						{{ refundData?.client?.emailAddress }}
					</p>
				</div>
			</div>
		</div>

		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3 min-h-[200px]"
		>
			<div class="border-b-2 pt-5 flex justify-between">
				<p
					class="text-font-18 mt-5 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'REFUND.REFUND_DETAILS.BRANCH_INFO' | translate }}
				</p>
				<button
					[routerLink]="
						'../../../service-providers/organization-profile/branch-information/' +
						refundData?.branch?.id
					"
					class="border border-solid border-secondry-color-Gray text-dark-grey hover:bg-gradient hover:text-off-white rounded-lg max-mobile:text-[8px]"
					mat-button
				>
					{{ 'REFUND.REFUND_DETAILS.VIEW_BRANCH' | translate }}
				</button>
			</div>

			<div class="flex pt-4">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.SALON_NAME' | translate }}
				</p>
				<div
					[routerLink]="
						'../../../service-providers/organization-profile/' +
						refundData?.branch?.serviceProviderId
					"
					class="w-[50%] flex cursor-pointer"
				>
					<img
						[src]="imagePath + refundData?.branch?.serviceProviderLogoPath"
						_ngcontent-stv-c258=""
						alt=""
						class="w-[33px] h-[33px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
					/>
					<p class="text-medium-gray text-font-12 mt-2">
						{{ refundData?.branch?.serviceProviderName }}
					</p>
				</div>
			</div>
			<div class="-4 flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.BRANCH_NAME' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.branch?.name }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">{{ 'REFUND.REFUND_DETAILS.PHONE' | translate }}</p>
				<div class="flex flex-col leading-3">
					<p
						*ngFor="let phone of refundData?.branch?.mobileNumbers"
						class="text-medium-gray text-font-12"
					>
						{{ phone?.phoneCode }}{{ phone?.mobileNumber }}
					</p>
				</div>
			</div>
		</div>
	</div>
</div>

<!-- case request -->

<div
	*ngIf="refundData?.refundStatus == 1"
	class="max-tablet:block flex gap-3 rounded-lg"
>
	<div class="flex-col w-full">
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3"
		>
			<div class="border-b-2 pt-5 flex justify-between items-center">
				<p
					class="text-font-18 mt-3 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'REFUND.REFUND_DETAILS.REFUND_INFO' | translate }}
				</p>

				<app-status
					[enumData]="refundStatus"
					[statusValue]="refundData?.refundStatus"
				></app-status>
			</div>
			<div class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REQUEST_NO' | translate }}
				</p>
				<p class="text-[#007AFF] text-font-12 w-[50%]">#{{ refundData?.id }}</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.BOOKING_NO' | translate }}
				</p>
				<p
					[routerLink]="
						'../../../booking/booking-details/' + refundData?.appointmentId
					"
					class="text-medium-gray text-font-12 w-[50%]"
				>
					#{{ refundData?.appointmentSerialNumber }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REQUEST_DATE' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.requestDate | date : 'dd / MM / yyy' }}
				</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.TIME' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.requestDate | date : 'h:mm a' }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REQUEST_AMOUNT' | translate }}
				</p>
				<p class="text-[#00BA88] text-font-12 w-[50%]">
					{{ refundData?.requestAmount }}
					{{
						translate.currentLang == 'ar'
							? refundData?.currency?.name?.ar
							: refundData?.currency?.name?.en
					}}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.BOOKING_AMOUNT' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.bookingAmount }}
					{{
						translate.currentLang == 'ar'
							? refundData?.currency?.name?.ar
							: refundData?.currency?.name?.en
					}}
				</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REFUND_BY' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.actionUserName }}
				</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.REQUEST_REASON' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.requestReason }}
				</p>
			</div>
		</div>

		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3 min-h-[200px]"
		>
			<div class="border-b-2 pt-5 flex justify-between">
				<p
					class="text-font-18 mt-5 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'REFUND.REFUND_DETAILS.CLIENT_INFO' | translate }}
				</p>
				<button
					[routerLink]="
						'../../../clients/client-profile/' + refundData?.client?.id
					"
					class="border border-solid border-secondry-color-Gray text-dark-grey hover:bg-gradient hover:text-off-white rounded-lg max-mobile:text-[8px]"
					mat-button
				>
					{{ 'REFUND.REFUND_DETAILS.VIEW_PROFILE' | translate }}
				</button>
			</div>
			<div class="pt-4 flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.CLIENT_NAME' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.client?.name }}
				</p>
			</div>

			<div class="flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.PHONE' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.client?.mobileNumber }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">{{ 'REFUND.REFUND_DETAILS.EMAIL' | translate }}</p>
				<div class="flex flex-col leading-3">
					<p class="text-medium-gray text-font-12">
						{{ refundData?.client?.emailAddress }}
					</p>
				</div>
			</div>
		</div>

		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3 min-h-[200px]"
		>
			<div class="border-b-2 pt-5 flex justify-between">
				<p
					class="text-font-18 mt-5 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'REFUND.REFUND_DETAILS.BRANCH_INFO' | translate }}
				</p>
				<button
					[routerLink]="
						'../../../service-providers/organization-profile/branch-information/' +
						refundData?.branch?.id
					"
					class="border border-solid border-secondry-color-Gray text-dark-grey hover:bg-gradient hover:text-off-white rounded-lg max-mobile:text-[8px]"
					mat-button
				>
					{{ 'REFUND.REFUND_DETAILS.VIEW_BRANCH' | translate }}
				</button>
			</div>

			<div class="flex pt-4">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.SALON_NAME' | translate }}
				</p>
				<div
					[routerLink]="
						'../../../service-providers/organization-profile/' +
						refundData?.branch?.serviceProviderId
					"
					class="w-[50%] flex cursor-pointer"
				>
					<img
						[src]="imagePath + refundData?.branch?.serviceProviderLogoPath"
						_ngcontent-stv-c258=""
						alt=""
						class="w-[33px] h-[33px] rtl:ml-2 ltr:mr-2 max-mobile:w-[40px] max-mobile:h-[40px] rounded-full"
					/>
					<p class="text-medium-gray text-font-12 mt-2">
						{{ refundData?.branch?.serviceProviderName }}
					</p>
				</div>
			</div>
			<div class="-4 flex">
				<p class="w-[50%]">
					{{ 'REFUND.REFUND_DETAILS.BRANCH_NAME' | translate }}
				</p>
				<p class="text-medium-gray text-font-12 w-[50%]">
					{{ refundData?.branch?.name }}
				</p>
			</div>
			<div class="flex">
				<p class="w-[50%]">{{ 'REFUND.REFUND_DETAILS.PHONE' | translate }}</p>
				<div class="flex flex-col leading-3">
					<p
						*ngFor="let phone of refundData?.branch?.mobileNumbers"
						class="text-medium-gray text-font-12"
					>
						{{ phone?.phoneCode }}{{ phone?.mobileNumber }}
					</p>
				</div>
			</div>
		</div>
	</div>

	<div [formGroup]="formData" class="flex-col w-full">
		<div
			class="flex flex-col text-dark-grey bg-off-white px-6 pb-3 rounded-lg mb-3 min-h-[350px]"
		>
			<div class="border-b-2 pt-5">
				<p
					class="text-font-18 mt-5 text-dark-gray ltr:font-DIN-Bold font-bold rtl:font-medium"
				>
					{{ 'REFUND.REFUND_DETAILS.DECISION' | translate }}
				</p>
			</div>

			<div>
				<mat-radio-group
					aria-label="Select an option"
					class="my-[12px]"
					formControlName="payStatus"
				>
					<mat-radio-button
						(click)="
							getController('refundAmount').disable();
							getController('refundAmount').setValue(refundData?.bookingAmount)
						"
						[ngClass]="
							matValue == 1 ? 'border-[#7E2EB3] border-b-[1px]' : 'border-none'
						"
						[value]="1"
						class="p-12px"
					>
						{{
							'REFUND.REFUND_DETAILS.FULL_REFUND' | translate
						}}</mat-radio-button
					>
					<mat-radio-button
						(click)="
							getController('refundAmount').enable();
							getController('refundAmount').reset()
						"
						[ngClass]="
							matValue == 2 ? 'border-[#7E2EB3] border-b-[1px]' : 'border-none'
						"
						[value]="2"
						class="p-12px"
						class="p-12px"
					>
						{{
							'REFUND.REFUND_DETAILS.PARTIAL_REFUND' | translate
						}}</mat-radio-button
					>
				</mat-radio-group>
				<hr class="w-[60%] max-tablet:w-[70%] max-mobile:w-full mb-[6px]" />

				<mat-form-field appearance="outline" class="w-full relative my-[12px]">
					<mat-label class="text-dark-grey">{{
						'REFUND.REFUND_DETAILS.AMOUNT' | translate
					}}</mat-label>
					<input
						max="{{ refundData?.bookingAmount }}"
						[min]="1"
						[value]="
							getController('payStatus')?.value == 1
								? refundData?.bookingAmount
								: ''
						"
						class="text-font-16 text-[#4E4B66]"
						formControlName="refundAmount"
						matInput
						maxlength="4"
						placeholder="{{ 'REFUND.REFUND_DETAILS.AMOUNT' | translate }}"
						required
						type="number"
					/>
					<img
						(click)="getController('refundAmount')?.reset()"
						*ngIf="
							getController('refundAmount')?.value &&
							getController('payStatus')?.value != 1
						"
						alt=""
						class="cursor-pointer absolute ltr:right-0 rtl:left-0 inline-block top-[9px]"
						src="./assets/images/close-square.svg"
					/>
					<mat-error>
						<validation-message
							[controller]="getController('refundAmount')"
							controller_name="REFUND.REFUND_DETAILS.AMOUNT"
							pattern_Message="VALIDATION.NAME"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>
				<mat-form-field appearance="outline" class="w-full relative mb-[12px]">
					<mat-label class="text-dark-grey">{{
						'REFUND.REFUND_DETAILS.REASON' | translate
					}}</mat-label>
					<input
						class="text-font-16 text-[#4E4B66]"
						formControlName="refundActionNotes"
						matInput
						placeholder="{{ 'REFUND.REFUND_DETAILS.REASON' | translate }}"
						required
						type="text"
					/>
					<img
						(click)="getController('refundActionNotes')?.reset()"
						*ngIf="getController('refundActionNotes')?.value"
						alt=""
						class="cursor-pointer absolute ltr:right-0 rtl:left-0 inline-block top-[9px]"
						src="./assets/images/close-square.svg"
					/>
					<mat-error>
						<validation-message
							[controller]="getController('refundActionNotes')"
							controller_name="REFUND.REFUND_DETAILS.REASON"
							pattern_Message="VALIDATION.NAME"
						>
						</validation-message>
					</mat-error>
				</mat-form-field>

				<button
					(click)="acceptRefund()"
					[disabled]="formData.invalid"
					class="bg-gradient text-font-14 text-off-white rounded-[5px] w-full py-8px mb-2"
					mat-button
				>
					{{ 'ACTIONS.SUBMIT' | translate }}
				</button>
				<button
					(click)="rejectRefund()"
					class="bg-transparent text-font-14 border-solid border-[1px] secondry-color-Gray rounded-[5px] w-full py-8px mb-[8px]"
				>
					{{ 'ACTIONS.REJECT_REFUND' | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
